import { render, staticRenderFns } from "./SectionSex.vue?vue&type=template&id=60bf613e&scoped=true&"
var script = {}
import style0 from "./SectionSex.vue?vue&type=style&index=0&id=60bf613e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bf613e",
  null
  
)

export default component.exports